import * as URL from "../helpers/Constants";
import axios from "axios";

export default class profitSharingPlanService {
    static getAllProfitSharingPlans(page, size) {
        return axios.get(URL.GET_ALL_PROFIT_SHARING_PLANS, {
            ...profitSharingPlanService.getAuthHeader(),
            params: {size, page}
        });
    }

    static getProfitSharingPlanById(id) {
        return axios.get(`${URL.GET_PROFIT_SHARING_PLAN_BY_ID}/${id}`, profitSharingPlanService.getAuthHeader());
    }

    static addProfitSharingPlan(data) {
        return axios.post(URL.POST_PROFIT_SHARING_PLAN, data, profitSharingPlanService.getAuthHeader());
    }

    static updateProfitSharingPlan(data, id) {
        return axios.put(`${URL.UPDATE_PROFIT_SHARING_PLAN}/${id}`, data, profitSharingPlanService.getAuthHeader());
    }

    static deleteProfitSharingPlan(id) {
        return axios.delete(`${URL.DELETE_PROFIT_SHARING_PLAN}/${id}`, profitSharingPlanService.getAuthHeader());
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        const options = {headers: {"Authorization": `Bearer ${accessToken}`}}
        return options;
    }

    // static changeProfitSharingPlanStatus(email, status) {
    //     return axios.post(`${URL.UPDATE_PROFIT_SHARING_PLAN_STATUS}/${email}?status=${status}`)
    // }
}